import { getWeekNumber } from '@/helpers/date-helper';

export const CURRENT_CALENDAR_WEEK_KEY = `cw_${new Date().getFullYear()}_${getWeekNumber(new Date())}`;

export const TRAILER_RADAR_CONFIG_NAME = 'TRAILER_RADAR';
